var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "service-lock-setting" },
    [
      _c(
        "el-tabs",
        {
          staticStyle: { "margin-top": "8px" },
          attrs: { type: "card" },
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.activeTabName,
            callback: function($$v) {
              _vm.activeTabName = $$v
            },
            expression: "activeTabName"
          }
        },
        [
          _c(
            "el-tab-pane",
            {
              attrs: {
                label: _vm.$t("CargoMsg.Cargo_ServiceLockSettings"),
                name: "lockSetting"
              }
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "padding-left": "8px",
                    "padding-top": "8px"
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "filters" },
                    [
                      _c(
                        "el-form",
                        {
                          attrs: {
                            inline: true,
                            "label-width": "100px",
                            "label-position": "right"
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "el-form-item-wrapper" },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    "label-width": "50px",
                                    label: _vm.$t("SystemMaintenance.Branch")
                                  }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      attrs: { no: "1", filterable: "" },
                                      on: {
                                        change: function($event) {
                                          return _vm.changeBranch()
                                        }
                                      },
                                      model: {
                                        value: _vm.form.branchId,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "branchId", $$v)
                                        },
                                        expression: "form.branchId"
                                      }
                                    },
                                    _vm._l(_vm.currentOfficeList, function(
                                      office
                                    ) {
                                      return _c("el-option", {
                                        key: office.officeId,
                                        attrs: {
                                          value: office.officeId,
                                          label: office.code
                                        }
                                      })
                                    }),
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.form.branchId !== 1,
                                      expression: "form.branchId!==1"
                                    }
                                  ]
                                },
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      on: { change: _vm.applyHq },
                                      model: {
                                        value: _vm.form.useParent,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "useParent", $$v)
                                        },
                                        expression: "form.useParent"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "CargoMsg.Cargo_GeneralSettings"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "primary" },
                                      on: { click: _vm.toSave }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("CargoMsg.Cargo_Save"))
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c("br")
                    ],
                    1
                  ),
                  _vm.form.useParent
                    ? _c("div", {
                        staticStyle: {
                          position: "absolute",
                          top: "40px",
                          left: "0",
                          right: "0",
                          bottom: "0",
                          "background-color": "rgba(0,0,0,.2)",
                          cursor: "not-allowed",
                          "z-index": "10"
                        }
                      })
                    : _vm._e(),
                  _c(
                    "div",
                    {
                      staticClass: "show-right section",
                      staticStyle: {
                        width: "60%",
                        "background-color": "#FFFFFF"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "main-content left",
                          staticStyle: {
                            "margin-top": "20px",
                            "margin-left": "30px",
                            "margin-bottom": "100px"
                          }
                        },
                        [
                          _c(
                            "el-form",
                            {
                              attrs: {
                                inline: true,
                                "label-width": "100px",
                                "label-position": "right"
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "el-form-item-wrapper" },
                                [
                                  _c("el-form-item", [
                                    _c("span", { staticClass: "title" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "CargoMsg.Cargo_AutomaticallyLocksServiceData"
                                          )
                                        )
                                      )
                                    ])
                                  ]),
                                  _c(
                                    "el-form-item",
                                    [
                                      _c("el-checkbox", {
                                        attrs: { no: "2" },
                                        model: {
                                          value: _vm.form.autoLock,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "autoLock", $$v)
                                          },
                                          expression: "form.autoLock"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "CargoMsg.Cargo_BusinessDate1"
                                        ),
                                        "label-width": _vm.isZh
                                          ? "100px"
                                          : "150px"
                                      }
                                    },
                                    [
                                      _c("auto-number-input", {
                                        attrs: { no: "3", min: 3, max: 120 },
                                        model: {
                                          value: _vm.form.day,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "day", $$v)
                                          },
                                          expression: "form.day"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c("el-form-item", {
                                    attrs: {
                                      label: _vm.$t("CargoMsg.Cargo_Days1"),
                                      "label-width": "25px"
                                    }
                                  }),
                                  _c(
                                    "el-form-item",
                                    [
                                      _c("el-tooltip", [
                                        _c("i", {
                                          staticClass: "el-icon-warning",
                                          staticStyle: {
                                            color: "#e6a23c",
                                            "margin-left": "5px"
                                          }
                                        })
                                      ]),
                                      _c("label", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "CargoMsg.Cargo_OnlyServiceDataLocked"
                                            )
                                          )
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "el-form-item-wrapper",
                                  staticStyle: { "margin-top": "20px" }
                                },
                                [
                                  _c("el-form-item", [
                                    _c("span", { staticClass: "title" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "CargoMsg.Cargo_AutomaticallySubmitServiceData"
                                          )
                                        )
                                      )
                                    ])
                                  ]),
                                  _c(
                                    "el-form-item",
                                    [
                                      _c("el-checkbox", {
                                        attrs: { no: "autoSubmit" },
                                        on: { change: _vm.changeAutoSubmit },
                                        model: {
                                          value: _vm.form.autoSubmit,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "autoSubmit",
                                              $$v
                                            )
                                          },
                                          expression: "form.autoSubmit"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    [
                                      _c("el-tooltip", [
                                        _c("i", {
                                          staticClass: "el-icon-warning",
                                          staticStyle: {
                                            color: "#e6a23c",
                                            "margin-left": "5px"
                                          }
                                        })
                                      ]),
                                      _c("label", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "CargoMsg.Cargo_ServicesNotSubmittedAutomaticallySubmitted"
                                            )
                                          )
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "el-form-item-wrapper" },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "CargoMsg.Cargo_OceanExport"
                                        )
                                      }
                                    },
                                    [
                                      _c("el-checkbox", {
                                        attrs: {
                                          no: "se",
                                          disabled: !_vm.form.autoSubmit
                                        },
                                        on: {
                                          change: function($event) {
                                            return _vm.chargeLobChecked(
                                              _vm.SystemConstants.SE.code
                                            )
                                          }
                                        },
                                        model: {
                                          value: _vm.form.se,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "se", $$v)
                                          },
                                          expression: "form.se"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          attrs: {
                                            no: "seDateType",
                                            disabled: !(
                                              _vm.form.autoSubmit && _vm.form.se
                                            )
                                          },
                                          model: {
                                            value: _vm.form.seDateType,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "seDateType",
                                                $$v
                                              )
                                            },
                                            expression: "form.seDateType"
                                          }
                                        },
                                        _vm._l(_vm.etdDateType, function(item) {
                                          return _c("el-option", {
                                            key: item.code,
                                            attrs: {
                                              label: item.code,
                                              value: item.value
                                            }
                                          })
                                        }),
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "100px" },
                                          attrs: {
                                            value: 0,
                                            no: "sePone",
                                            disabled: !(
                                              _vm.form.autoSubmit && _vm.form.se
                                            )
                                          }
                                        },
                                        [
                                          _c("el-option", {
                                            attrs: {
                                              label: _vm.$t(
                                                "CargoMsg.Cargo_GreaterThan"
                                              ),
                                              value: 0
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    [
                                      _c("auto-number-input", {
                                        attrs: {
                                          no: "seDay",
                                          disabled: !(
                                            _vm.form.autoSubmit && _vm.form.se
                                          ),
                                          "enforce-min": true,
                                          min: 0
                                        },
                                        model: {
                                          value: _vm.form.seDay,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "seDay", $$v)
                                          },
                                          expression: "form.seDay"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c("el-form-item", {
                                    attrs: {
                                      label: _vm.$t("CargoMsg.Cargo_Days1"),
                                      "label-width": "25px"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "el-form-item-wrapper" },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "CargoMsg.Cargo_OceanImport"
                                        )
                                      }
                                    },
                                    [
                                      _c("el-checkbox", {
                                        attrs: {
                                          no: "si",
                                          disabled: !_vm.form.autoSubmit
                                        },
                                        on: {
                                          change: function($event) {
                                            return _vm.chargeLobChecked(
                                              _vm.SystemConstants.SI.code
                                            )
                                          }
                                        },
                                        model: {
                                          value: _vm.form.si,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "si", $$v)
                                          },
                                          expression: "form.si"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          attrs: {
                                            no: "siDateType",
                                            disabled: !(
                                              _vm.form.autoSubmit && _vm.form.si
                                            )
                                          },
                                          model: {
                                            value: _vm.form.siDateType,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "siDateType",
                                                $$v
                                              )
                                            },
                                            expression: "form.siDateType"
                                          }
                                        },
                                        _vm._l(_vm.etaDateType, function(item) {
                                          return _c("el-option", {
                                            key: item.code,
                                            attrs: {
                                              label: item.code,
                                              value: item.value
                                            }
                                          })
                                        }),
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "100px" },
                                          attrs: {
                                            value: 0,
                                            no: "siPone",
                                            disabled: !(
                                              _vm.form.autoSubmit && _vm.form.si
                                            )
                                          }
                                        },
                                        [
                                          _c("el-option", {
                                            attrs: {
                                              label: _vm.$t(
                                                "CargoMsg.Cargo_GreaterThan"
                                              ),
                                              value: 0
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    [
                                      _c("auto-number-input", {
                                        attrs: {
                                          no: "siDay",
                                          disabled: !(
                                            _vm.form.autoSubmit && _vm.form.si
                                          ),
                                          "enforce-min": true,
                                          min: 0
                                        },
                                        model: {
                                          value: _vm.form.siDay,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "siDay", $$v)
                                          },
                                          expression: "form.siDay"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c("el-form-item", {
                                    attrs: {
                                      label: _vm.$t("CargoMsg.Cargo_Days1"),
                                      "label-width": "25px"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "el-form-item-wrapper" },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "CargoMsg.Cargo_AirExport"
                                        )
                                      }
                                    },
                                    [
                                      _c("el-checkbox", {
                                        attrs: {
                                          no: "ae",
                                          disabled: !_vm.form.autoSubmit
                                        },
                                        on: {
                                          change: function($event) {
                                            return _vm.chargeLobChecked(
                                              _vm.SystemConstants.AE.code
                                            )
                                          }
                                        },
                                        model: {
                                          value: _vm.form.ae,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "ae", $$v)
                                          },
                                          expression: "form.ae"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          attrs: {
                                            no: "aeDateType",
                                            disabled: !(
                                              _vm.form.autoSubmit && _vm.form.ae
                                            )
                                          },
                                          model: {
                                            value: _vm.form.aeDateType,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "aeDateType",
                                                $$v
                                              )
                                            },
                                            expression: "form.aeDateType"
                                          }
                                        },
                                        _vm._l(_vm.etdDateType, function(item) {
                                          return _c("el-option", {
                                            key: item.code,
                                            attrs: {
                                              label: item.code,
                                              value: item.value
                                            }
                                          })
                                        }),
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "100px" },
                                          attrs: {
                                            value: 0,
                                            no: "aePone",
                                            disabled: !(
                                              _vm.form.autoSubmit && _vm.form.ae
                                            )
                                          }
                                        },
                                        [
                                          _c("el-option", {
                                            attrs: {
                                              label: _vm.$t(
                                                "CargoMsg.Cargo_GreaterThan"
                                              ),
                                              value: 0
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    [
                                      _c("auto-number-input", {
                                        attrs: {
                                          no: "aeDay",
                                          disabled: !(
                                            _vm.form.autoSubmit && _vm.form.ae
                                          ),
                                          "enforce-min": true,
                                          min: 0
                                        },
                                        model: {
                                          value: _vm.form.aeDay,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "aeDay", $$v)
                                          },
                                          expression: "form.aeDay"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c("el-form-item", {
                                    attrs: {
                                      label: _vm.$t("CargoMsg.Cargo_Days1"),
                                      "label-width": "25px"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "el-form-item-wrapper" },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "CargoMsg.Cargo_AirImport"
                                        )
                                      }
                                    },
                                    [
                                      _c("el-checkbox", {
                                        attrs: {
                                          no: "ai",
                                          disabled: !_vm.form.autoSubmit
                                        },
                                        on: {
                                          change: function($event) {
                                            return _vm.chargeLobChecked(
                                              _vm.SystemConstants.AI.code
                                            )
                                          }
                                        },
                                        model: {
                                          value: _vm.form.ai,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "ai", $$v)
                                          },
                                          expression: "form.ai"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          attrs: {
                                            no: "aiDateType",
                                            disabled: !(
                                              _vm.form.autoSubmit && _vm.form.ai
                                            )
                                          },
                                          model: {
                                            value: _vm.form.aiDateType,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "aiDateType",
                                                $$v
                                              )
                                            },
                                            expression: "form.aiDateType"
                                          }
                                        },
                                        _vm._l(_vm.etaDateType, function(item) {
                                          return _c("el-option", {
                                            key: item.code,
                                            attrs: {
                                              label: item.code,
                                              value: item.value
                                            }
                                          })
                                        }),
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "100px" },
                                          attrs: {
                                            value: 0,
                                            no: "aiPone",
                                            disabled: !(
                                              _vm.form.autoSubmit && _vm.form.ai
                                            )
                                          }
                                        },
                                        [
                                          _c("el-option", {
                                            attrs: {
                                              label: _vm.$t(
                                                "CargoMsg.Cargo_GreaterThan"
                                              ),
                                              value: 0
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    [
                                      _c("auto-number-input", {
                                        attrs: {
                                          no: "aiDay",
                                          disabled: !(
                                            _vm.form.autoSubmit && _vm.form.ai
                                          ),
                                          "enforce-min": true,
                                          min: 0
                                        },
                                        model: {
                                          value: _vm.form.aiDay,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "aiDay", $$v)
                                          },
                                          expression: "form.aiDay"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c("el-form-item", {
                                    attrs: {
                                      label: _vm.$t("CargoMsg.Cargo_Days1"),
                                      "label-width": "25px"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "el-form-item-wrapper" },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "CargoMsg.Cargo_RailwayExport"
                                        )
                                      }
                                    },
                                    [
                                      _c("el-checkbox", {
                                        attrs: {
                                          no: "re",
                                          disabled: !_vm.form.autoSubmit
                                        },
                                        on: {
                                          change: function($event) {
                                            return _vm.chargeLobChecked(
                                              _vm.SystemConstants.RE.code
                                            )
                                          }
                                        },
                                        model: {
                                          value: _vm.form.re,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "re", $$v)
                                          },
                                          expression: "form.re"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          attrs: {
                                            no: "reDateType",
                                            disabled: !(
                                              _vm.form.autoSubmit && _vm.form.re
                                            )
                                          },
                                          model: {
                                            value: _vm.form.reDateType,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "reDateType",
                                                $$v
                                              )
                                            },
                                            expression: "form.reDateType"
                                          }
                                        },
                                        _vm._l(_vm.etdDateType, function(item) {
                                          return _c("el-option", {
                                            key: item.code,
                                            attrs: {
                                              label: item.code,
                                              value: item.value
                                            }
                                          })
                                        }),
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "100px" },
                                          attrs: {
                                            value: 0,
                                            no: "rePone",
                                            disabled: !(
                                              _vm.form.autoSubmit && _vm.form.re
                                            )
                                          }
                                        },
                                        [
                                          _c("el-option", {
                                            attrs: {
                                              label: _vm.$t(
                                                "CargoMsg.Cargo_GreaterThan"
                                              ),
                                              value: 0
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    [
                                      _c("auto-number-input", {
                                        attrs: {
                                          no: "reDay",
                                          disabled: !(
                                            _vm.form.autoSubmit && _vm.form.re
                                          ),
                                          "enforce-min": true,
                                          min: 0
                                        },
                                        model: {
                                          value: _vm.form.reDay,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "reDay", $$v)
                                          },
                                          expression: "form.reDay"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c("el-form-item", {
                                    attrs: {
                                      label: _vm.$t("CargoMsg.Cargo_Days1"),
                                      "label-width": "25px"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "el-form-item-wrapper" },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "CargoMsg.Cargo_RailwayImport"
                                        )
                                      }
                                    },
                                    [
                                      _c("el-checkbox", {
                                        attrs: {
                                          no: "ri",
                                          disabled: !_vm.form.autoSubmit
                                        },
                                        on: {
                                          change: function($event) {
                                            return _vm.chargeLobChecked(
                                              _vm.SystemConstants.RI.code
                                            )
                                          }
                                        },
                                        model: {
                                          value: _vm.form.ri,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "ri", $$v)
                                          },
                                          expression: "form.ri"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          attrs: {
                                            no: "riDateType",
                                            disabled: !(
                                              _vm.form.autoSubmit && _vm.form.ri
                                            )
                                          },
                                          model: {
                                            value: _vm.form.riDateType,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "riDateType",
                                                $$v
                                              )
                                            },
                                            expression: "form.riDateType"
                                          }
                                        },
                                        _vm._l(_vm.etdDateType, function(item) {
                                          return _c("el-option", {
                                            key: item.code,
                                            attrs: {
                                              label: item.code,
                                              value: item.value
                                            }
                                          })
                                        }),
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "100px" },
                                          attrs: {
                                            value: 0,
                                            no: "riPone",
                                            disabled: !(
                                              _vm.form.autoSubmit && _vm.form.ri
                                            )
                                          }
                                        },
                                        [
                                          _c("el-option", {
                                            attrs: {
                                              label: _vm.$t(
                                                "CargoMsg.Cargo_GreaterThan"
                                              ),
                                              value: 0
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    [
                                      _c("auto-number-input", {
                                        attrs: {
                                          no: "riDay",
                                          disabled: !(
                                            _vm.form.autoSubmit && _vm.form.ri
                                          ),
                                          "enforce-min": true,
                                          min: 0
                                        },
                                        model: {
                                          value: _vm.form.riDay,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "riDay", $$v)
                                          },
                                          expression: "form.riDay"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c("el-form-item", {
                                    attrs: {
                                      label: _vm.$t("CargoMsg.Cargo_Days1"),
                                      "label-width": "25px"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "el-form-item-wrapper",
                                  staticStyle: { "margin-top": "20px" }
                                },
                                [
                                  _c("el-form-item", [
                                    _c("span", { staticClass: "title" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "CargoMsg.Cargo_AutoFinanceAuditLockOrder"
                                          )
                                        )
                                      )
                                    ])
                                  ]),
                                  _c(
                                    "el-form-item",
                                    [
                                      _c("el-checkbox", {
                                        attrs: { no: "autoFinanceSubmit" },
                                        on: {
                                          change: _vm.changeFinanceAutoSubmit
                                        },
                                        model: {
                                          value: _vm.form.autoFinanceSubmit,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "autoFinanceSubmit",
                                              $$v
                                            )
                                          },
                                          expression: "form.autoFinanceSubmit"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    [
                                      _c("el-tooltip", [
                                        _c("i", {
                                          staticClass: "el-icon-warning",
                                          staticStyle: {
                                            color: "#e6a23c",
                                            "margin-left": "5px"
                                          }
                                        })
                                      ]),
                                      _c("label", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "CargoMsg.Cargo_UnSubmittedBusinessLockOrder"
                                            )
                                          )
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "el-form-item-wrapper" },
                                [
                                  _c("el-form-item", [
                                    _c(
                                      "div",
                                      { staticStyle: { display: "flex" } },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "primary",
                                              disabled: !_vm.form
                                                .autoFinanceSubmit
                                            },
                                            on: { click: _vm.toFinanceAdd }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("CargoMsg.Cargo_add")
                                              )
                                            )
                                          ]
                                        ),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "danger",
                                              disabled: !_vm.form
                                                .autoFinanceSubmit
                                            },
                                            on: { click: _vm.toFinanceDelete }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("CargoMsg.Cargo_Delete")
                                              )
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ])
                                ],
                                1
                              ),
                              _vm._l(_vm.financeSetting, function(item, index) {
                                return _c("div", { key: index }, [
                                  _c("div", { staticClass: "scrollable-div" }, [
                                    _c(
                                      "div",
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "CargoMsg.Cargo_PollingFrequency"
                                              ),
                                              "label-width": "125px"
                                            }
                                          },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "150px" },
                                                attrs: {
                                                  no: "sePone",
                                                  disabled: !_vm.form
                                                    .autoFinanceSubmit
                                                },
                                                model: {
                                                  value: item.pollingFrequency,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "pollingFrequency",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "item.pollingFrequency"
                                                }
                                              },
                                              [
                                                _c("el-option", {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "CargoMsg.Cargo_DailyOnce"
                                                    ),
                                                    value: 0
                                                  }
                                                }),
                                                _c("el-option", {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "CargoMsg.Cargo_SpecificDateMonthly"
                                                    ),
                                                    value: 1
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          [
                                            _c("auto-number-input", {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value: item.pollingFrequency,
                                                  expression:
                                                    "item.pollingFrequency"
                                                }
                                              ],
                                              staticStyle: { width: "100px" },
                                              attrs: {
                                                no: "financeDay",
                                                disabled: !_vm.form
                                                  .autoFinanceSubmit,
                                                "enforce-min": true,
                                                min: 0
                                              },
                                              model: {
                                                value: item.financeDay,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    item,
                                                    "financeDay",
                                                    $$v
                                                  )
                                                },
                                                expression: "item.financeDay"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: " ",
                                              "label-width": item.pollingFrequency
                                                ? "120px"
                                                : "220px"
                                            }
                                          },
                                          [
                                            _c(
                                              "el-checkbox",
                                              {
                                                attrs: {
                                                  no: "ri",
                                                  disabled: !_vm.form
                                                    .autoFinanceSubmit
                                                },
                                                model: {
                                                  value: item.checked,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "checked",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "item.checked"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "CargoMsg.Cargo_Priority"
                                                    ) + item.num
                                                  )
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "CargoMsg.Cargo_IncoTerm"
                                              ),
                                              "label-width": "125px"
                                            }
                                          },
                                          [
                                            _c("cargo-advance-select", {
                                              staticStyle: { width: "150px" },
                                              attrs: {
                                                no: "incoTerm",
                                                filterable: "",
                                                "select-type":
                                                  _vm.selectTypeNames
                                                    .basic_data_ChargeItem,
                                                "default-multiple-value":
                                                  item.incoTerm,
                                                "tag-value": "code",
                                                "tag-name": "code",
                                                multiple: true,
                                                cache: false,
                                                "static-options":
                                                  _vm.incoTermList
                                              },
                                              on: {
                                                parentCallBack: function(p) {
                                                  return (item.incoTerm =
                                                    p.value)
                                                }
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "CargoMsg.Cargo_CustomJobType"
                                              ),
                                              "label-width": "110px"
                                            }
                                          },
                                          [
                                            _c("cargo-advance-select", {
                                              staticStyle: { width: "150px" },
                                              attrs: {
                                                no: "customJobType",
                                                filterable: "",
                                                "select-type":
                                                  _vm.selectTypeNames
                                                    .basic_data_CutomJobType,
                                                "default-multiple-value":
                                                  item.customJobType,
                                                "tag-value": "code",
                                                "tag-name": "code",
                                                multiple: true
                                              },
                                              on: {
                                                parentCallBack: function(p) {
                                                  return (item.customJobType =
                                                    p.value)
                                                }
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "el-form-item-wrapper" },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "CargoMsg.Cargo_OceanExport"
                                              )
                                            }
                                          },
                                          [
                                            _c("el-checkbox", {
                                              attrs: {
                                                no: "se",
                                                disabled: !_vm.form
                                                  .autoFinanceSubmit
                                              },
                                              on: {
                                                change: function($event) {
                                                  return _vm.chargeFinanceLobChecked(
                                                    _vm.SystemConstants.SE.code,
                                                    item
                                                  )
                                                }
                                              },
                                              model: {
                                                value: item.se,
                                                callback: function($$v) {
                                                  _vm.$set(item, "se", $$v)
                                                },
                                                expression: "item.se"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "100px" },
                                                attrs: {
                                                  no: "seDateType",
                                                  disabled: !(
                                                    _vm.form
                                                      .autoFinanceSubmit &&
                                                    item.se
                                                  )
                                                },
                                                model: {
                                                  value: item.seDateType,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "seDateType",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "item.seDateType"
                                                }
                                              },
                                              _vm._l(
                                                _vm.financeEtdDateType,
                                                function(item) {
                                                  return _c("el-option", {
                                                    key: item.code,
                                                    attrs: {
                                                      label: item.code,
                                                      value: item.value
                                                    }
                                                  })
                                                }
                                              ),
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "100px" },
                                                attrs: {
                                                  value: 0,
                                                  no: "sePone",
                                                  disabled: !(
                                                    _vm.form
                                                      .autoFinanceSubmit &&
                                                    item.se
                                                  )
                                                }
                                              },
                                              [
                                                _c("el-option", {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "CargoMsg.Cargo_GreaterThan"
                                                    ),
                                                    value: 0
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          [
                                            _c("auto-number-input", {
                                              staticStyle: { width: "100px" },
                                              attrs: {
                                                no: "seDay",
                                                disabled: !(
                                                  _vm.form.autoFinanceSubmit &&
                                                  item.se
                                                ),
                                                "enforce-min": true,
                                                min: 0
                                              },
                                              model: {
                                                value: item.seDay,
                                                callback: function($$v) {
                                                  _vm.$set(item, "seDay", $$v)
                                                },
                                                expression: "item.seDay"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "70px" },
                                                attrs: {
                                                  no: "seDayUnit",
                                                  disabled: !(
                                                    _vm.form
                                                      .autoFinanceSubmit &&
                                                    item.se
                                                  )
                                                },
                                                model: {
                                                  value: item.seDayUnit,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "seDayUnit",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "item.seDayUnit"
                                                }
                                              },
                                              [
                                                _c("el-option", {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "CargoMsg.Cargo_Days"
                                                    ),
                                                    value: 0
                                                  }
                                                }),
                                                _c("el-option", {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "CargoMsg.Cargo_Month"
                                                    ),
                                                    value: 1
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            item.seDayUnit === 1
                                              ? _c(
                                                  "el-tooltip",
                                                  {
                                                    attrs: {
                                                      content: _vm.$t(
                                                        "CargoMsg.Cargo_FinanceMonthUnitTip"
                                                      ),
                                                      placement: "top"
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "el-icon-warning",
                                                      staticStyle: {
                                                        "margin-left": "2px",
                                                        color: "#E6A23C",
                                                        "font-size": "14px"
                                                      }
                                                    })
                                                  ]
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "el-form-item-wrapper" },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "CargoMsg.Cargo_OceanImport"
                                              )
                                            }
                                          },
                                          [
                                            _c("el-checkbox", {
                                              attrs: {
                                                no: "si",
                                                disabled: !_vm.form
                                                  .autoFinanceSubmit
                                              },
                                              on: {
                                                change: function($event) {
                                                  return _vm.chargeFinanceLobChecked(
                                                    _vm.SystemConstants.SI.code,
                                                    item
                                                  )
                                                }
                                              },
                                              model: {
                                                value: item.si,
                                                callback: function($$v) {
                                                  _vm.$set(item, "si", $$v)
                                                },
                                                expression: "item.si"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "100px" },
                                                attrs: {
                                                  no: "siDateType",
                                                  disabled: !(
                                                    _vm.form
                                                      .autoFinanceSubmit &&
                                                    item.si
                                                  )
                                                },
                                                model: {
                                                  value: item.siDateType,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "siDateType",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "item.siDateType"
                                                }
                                              },
                                              _vm._l(
                                                _vm.financeAtdDateType,
                                                function(item) {
                                                  return _c("el-option", {
                                                    key: item.code,
                                                    attrs: {
                                                      label: item.code,
                                                      value: item.value
                                                    }
                                                  })
                                                }
                                              ),
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "100px" },
                                                attrs: {
                                                  value: 0,
                                                  no: "siPone",
                                                  disabled: !(
                                                    _vm.form
                                                      .autoFinanceSubmit &&
                                                    item.si
                                                  )
                                                }
                                              },
                                              [
                                                _c("el-option", {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "CargoMsg.Cargo_GreaterThan"
                                                    ),
                                                    value: 0
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          [
                                            _c("auto-number-input", {
                                              staticStyle: { width: "100px" },
                                              attrs: {
                                                no: "siDay",
                                                disabled: !(
                                                  _vm.form.autoFinanceSubmit &&
                                                  item.si
                                                ),
                                                "enforce-min": true,
                                                min: 0
                                              },
                                              model: {
                                                value: item.siDay,
                                                callback: function($$v) {
                                                  _vm.$set(item, "siDay", $$v)
                                                },
                                                expression: "item.siDay"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "70px" },
                                                attrs: {
                                                  no: "siDayUnit",
                                                  disabled: !(
                                                    _vm.form
                                                      .autoFinanceSubmit &&
                                                    item.si
                                                  )
                                                },
                                                model: {
                                                  value: item.siDayUnit,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "siDayUnit",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "item.siDayUnit"
                                                }
                                              },
                                              [
                                                _c("el-option", {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "CargoMsg.Cargo_Days"
                                                    ),
                                                    value: 0
                                                  }
                                                }),
                                                _c("el-option", {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "CargoMsg.Cargo_Month"
                                                    ),
                                                    value: 1
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            item.siDayUnit === 1
                                              ? _c(
                                                  "el-tooltip",
                                                  {
                                                    attrs: {
                                                      content: _vm.$t(
                                                        "CargoMsg.Cargo_FinanceMonthUnitTip"
                                                      ),
                                                      placement: "top"
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "el-icon-warning",
                                                      staticStyle: {
                                                        "margin-left": "2px",
                                                        color: "#E6A23C",
                                                        "font-size": "14px"
                                                      }
                                                    })
                                                  ]
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "el-form-item-wrapper" },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "CargoMsg.Cargo_AirExport"
                                              )
                                            }
                                          },
                                          [
                                            _c("el-checkbox", {
                                              attrs: {
                                                no: "ae",
                                                disabled: !_vm.form
                                                  .autoFinanceSubmit
                                              },
                                              on: {
                                                change: function($event) {
                                                  return _vm.chargeFinanceLobChecked(
                                                    _vm.SystemConstants.AE.code,
                                                    item
                                                  )
                                                }
                                              },
                                              model: {
                                                value: item.ae,
                                                callback: function($$v) {
                                                  _vm.$set(item, "ae", $$v)
                                                },
                                                expression: "item.ae"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "100px" },
                                                attrs: {
                                                  no: "aeDateType",
                                                  disabled: !(
                                                    _vm.form
                                                      .autoFinanceSubmit &&
                                                    item.ae
                                                  )
                                                },
                                                model: {
                                                  value: item.aeDateType,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "aeDateType",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "item.aeDateType"
                                                }
                                              },
                                              _vm._l(
                                                _vm.financeEtdDateType,
                                                function(item) {
                                                  return _c("el-option", {
                                                    key: item.code,
                                                    attrs: {
                                                      label: item.code,
                                                      value: item.value
                                                    }
                                                  })
                                                }
                                              ),
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "100px" },
                                                attrs: {
                                                  value: 0,
                                                  no: "aePone",
                                                  disabled: !(
                                                    _vm.form
                                                      .autoFinanceSubmit &&
                                                    item.ae
                                                  )
                                                }
                                              },
                                              [
                                                _c("el-option", {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "CargoMsg.Cargo_GreaterThan"
                                                    ),
                                                    value: 0
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          [
                                            _c("auto-number-input", {
                                              staticStyle: { width: "100px" },
                                              attrs: {
                                                no: "aeDay",
                                                disabled: !(
                                                  _vm.form.autoFinanceSubmit &&
                                                  item.ae
                                                ),
                                                "enforce-min": true,
                                                min: 0
                                              },
                                              model: {
                                                value: item.aeDay,
                                                callback: function($$v) {
                                                  _vm.$set(item, "aeDay", $$v)
                                                },
                                                expression: "item.aeDay"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "70px" },
                                                attrs: {
                                                  no: "aeDayUnit",
                                                  disabled: !(
                                                    _vm.form
                                                      .autoFinanceSubmit &&
                                                    item.ae
                                                  )
                                                },
                                                model: {
                                                  value: item.aeDayUnit,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "aeDayUnit",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "item.aeDayUnit"
                                                }
                                              },
                                              [
                                                _c("el-option", {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "CargoMsg.Cargo_Days"
                                                    ),
                                                    value: 0
                                                  }
                                                }),
                                                _c("el-option", {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "CargoMsg.Cargo_Month"
                                                    ),
                                                    value: 1
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            item.aeDayUnit === 1
                                              ? _c(
                                                  "el-tooltip",
                                                  {
                                                    attrs: {
                                                      content: _vm.$t(
                                                        "CargoMsg.Cargo_FinanceMonthUnitTip"
                                                      ),
                                                      placement: "top"
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "el-icon-warning",
                                                      staticStyle: {
                                                        "margin-left": "2px",
                                                        color: "#E6A23C",
                                                        "font-size": "14px"
                                                      }
                                                    })
                                                  ]
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "el-form-item-wrapper" },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "CargoMsg.Cargo_AirImport"
                                              )
                                            }
                                          },
                                          [
                                            _c("el-checkbox", {
                                              attrs: {
                                                no: "ai",
                                                disabled: !_vm.form
                                                  .autoFinanceSubmit
                                              },
                                              on: {
                                                change: function($event) {
                                                  return _vm.chargeFinanceLobChecked(
                                                    _vm.SystemConstants.AI.code,
                                                    item
                                                  )
                                                }
                                              },
                                              model: {
                                                value: item.ai,
                                                callback: function($$v) {
                                                  _vm.$set(item, "ai", $$v)
                                                },
                                                expression: "item.ai"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "100px" },
                                                attrs: {
                                                  no: "aiDateType",
                                                  disabled: !(
                                                    _vm.form
                                                      .autoFinanceSubmit &&
                                                    item.ai
                                                  )
                                                },
                                                model: {
                                                  value: item.aiDateType,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "aiDateType",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "item.aiDateType"
                                                }
                                              },
                                              _vm._l(
                                                _vm.financeAtdDateType,
                                                function(item) {
                                                  return _c("el-option", {
                                                    key: item.code,
                                                    attrs: {
                                                      label: item.code,
                                                      value: item.value
                                                    }
                                                  })
                                                }
                                              ),
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "100px" },
                                                attrs: {
                                                  value: 0,
                                                  no: "aiPone",
                                                  disabled: !(
                                                    _vm.form
                                                      .autoFinanceSubmit &&
                                                    item.ai
                                                  )
                                                }
                                              },
                                              [
                                                _c("el-option", {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "CargoMsg.Cargo_GreaterThan"
                                                    ),
                                                    value: 0
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          [
                                            _c("auto-number-input", {
                                              staticStyle: { width: "100px" },
                                              attrs: {
                                                no: "aiDay",
                                                disabled: !(
                                                  _vm.form.autoFinanceSubmit &&
                                                  item.ai
                                                ),
                                                "enforce-min": true,
                                                min: 0
                                              },
                                              model: {
                                                value: item.aiDay,
                                                callback: function($$v) {
                                                  _vm.$set(item, "aiDay", $$v)
                                                },
                                                expression: "item.aiDay"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "70px" },
                                                attrs: {
                                                  no: "aiDayUnit",
                                                  disabled: !(
                                                    _vm.form
                                                      .autoFinanceSubmit &&
                                                    item.ai
                                                  )
                                                },
                                                model: {
                                                  value: item.aiDayUnit,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "aiDayUnit",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "item.aiDayUnit"
                                                }
                                              },
                                              [
                                                _c("el-option", {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "CargoMsg.Cargo_Days"
                                                    ),
                                                    value: 0
                                                  }
                                                }),
                                                _c("el-option", {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "CargoMsg.Cargo_Month"
                                                    ),
                                                    value: 1
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            item.aiDayUnit === 1
                                              ? _c(
                                                  "el-tooltip",
                                                  {
                                                    attrs: {
                                                      content: _vm.$t(
                                                        "CargoMsg.Cargo_FinanceMonthUnitTip"
                                                      ),
                                                      placement: "top"
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "el-icon-warning",
                                                      staticStyle: {
                                                        "margin-left": "2px",
                                                        color: "#E6A23C",
                                                        "font-size": "14px"
                                                      }
                                                    })
                                                  ]
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "el-form-item-wrapper" },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "CargoMsg.Cargo_RailwayExport"
                                              )
                                            }
                                          },
                                          [
                                            _c("el-checkbox", {
                                              attrs: {
                                                no: "re",
                                                disabled: !_vm.form
                                                  .autoFinanceSubmit
                                              },
                                              on: {
                                                change: function($event) {
                                                  return _vm.chargeFinanceLobChecked(
                                                    _vm.SystemConstants.RE.code,
                                                    item
                                                  )
                                                }
                                              },
                                              model: {
                                                value: item.re,
                                                callback: function($$v) {
                                                  _vm.$set(item, "re", $$v)
                                                },
                                                expression: "item.re"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "100px" },
                                                attrs: {
                                                  no: "reDateType",
                                                  disabled: !(
                                                    _vm.form
                                                      .autoFinanceSubmit &&
                                                    item.re
                                                  )
                                                },
                                                model: {
                                                  value: item.reDateType,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "reDateType",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "item.reDateType"
                                                }
                                              },
                                              _vm._l(
                                                _vm.financeEtdDateType,
                                                function(item) {
                                                  return _c("el-option", {
                                                    key: item.code,
                                                    attrs: {
                                                      label: item.code,
                                                      value: item.value
                                                    }
                                                  })
                                                }
                                              ),
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "100px" },
                                                attrs: {
                                                  value: 0,
                                                  no: "rePone",
                                                  disabled: !(
                                                    _vm.form
                                                      .autoFinanceSubmit &&
                                                    item.re
                                                  )
                                                }
                                              },
                                              [
                                                _c("el-option", {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "CargoMsg.Cargo_GreaterThan"
                                                    ),
                                                    value: 0
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          [
                                            _c("auto-number-input", {
                                              staticStyle: { width: "100px" },
                                              attrs: {
                                                no: "reDay",
                                                disabled: !(
                                                  _vm.form.autoFinanceSubmit &&
                                                  item.re
                                                ),
                                                "enforce-min": true,
                                                min: 0
                                              },
                                              model: {
                                                value: item.reDay,
                                                callback: function($$v) {
                                                  _vm.$set(item, "reDay", $$v)
                                                },
                                                expression: "item.reDay"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "70px" },
                                                attrs: {
                                                  no: "reDayUnit",
                                                  disabled: !(
                                                    _vm.form
                                                      .autoFinanceSubmit &&
                                                    item.re
                                                  )
                                                },
                                                model: {
                                                  value: item.reDayUnit,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "reDayUnit",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "item.reDayUnit"
                                                }
                                              },
                                              [
                                                _c("el-option", {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "CargoMsg.Cargo_Days"
                                                    ),
                                                    value: 0
                                                  }
                                                }),
                                                _c("el-option", {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "CargoMsg.Cargo_Month"
                                                    ),
                                                    value: 1
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            item.reDayUnit === 1
                                              ? _c(
                                                  "el-tooltip",
                                                  {
                                                    attrs: {
                                                      content: _vm.$t(
                                                        "CargoMsg.Cargo_FinanceMonthUnitTip"
                                                      ),
                                                      placement: "top"
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "el-icon-warning",
                                                      staticStyle: {
                                                        "margin-left": "2px",
                                                        color: "#E6A23C",
                                                        "font-size": "14px"
                                                      }
                                                    })
                                                  ]
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "el-form-item-wrapper" },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "CargoMsg.Cargo_RailwayImport"
                                              )
                                            }
                                          },
                                          [
                                            _c("el-checkbox", {
                                              attrs: {
                                                no: "ri",
                                                disabled: !_vm.form
                                                  .autoFinanceSubmit
                                              },
                                              on: {
                                                change: function($event) {
                                                  return _vm.chargeFinanceLobChecked(
                                                    _vm.SystemConstants.RI.code,
                                                    item
                                                  )
                                                }
                                              },
                                              model: {
                                                value: item.ri,
                                                callback: function($$v) {
                                                  _vm.$set(item, "ri", $$v)
                                                },
                                                expression: "item.ri"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "100px" },
                                                attrs: {
                                                  no: "riDateType",
                                                  disabled: !(
                                                    _vm.form
                                                      .autoFinanceSubmit &&
                                                    item.ri
                                                  )
                                                },
                                                model: {
                                                  value: item.riDateType,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "riDateType",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "item.riDateType"
                                                }
                                              },
                                              _vm._l(
                                                _vm.financeAtdDateType,
                                                function(item) {
                                                  return _c("el-option", {
                                                    key: item.code,
                                                    attrs: {
                                                      label: item.code,
                                                      value: item.value
                                                    }
                                                  })
                                                }
                                              ),
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "100px" },
                                                attrs: {
                                                  value: 0,
                                                  no: "riPone",
                                                  disabled: !(
                                                    _vm.form
                                                      .autoFinanceSubmit &&
                                                    item.ri
                                                  )
                                                }
                                              },
                                              [
                                                _c("el-option", {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "CargoMsg.Cargo_GreaterThan"
                                                    ),
                                                    value: 0
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          [
                                            _c("auto-number-input", {
                                              staticStyle: { width: "100px" },
                                              attrs: {
                                                no: "riDay",
                                                disabled: !(
                                                  _vm.form.autoFinanceSubmit &&
                                                  item.ri
                                                ),
                                                "enforce-min": true,
                                                min: 0
                                              },
                                              model: {
                                                value: item.riDay,
                                                callback: function($$v) {
                                                  _vm.$set(item, "riDay", $$v)
                                                },
                                                expression: "item.riDay"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "70px" },
                                                attrs: {
                                                  no: "riDayUnit",
                                                  disabled: !(
                                                    _vm.form
                                                      .autoFinanceSubmit &&
                                                    item.ri
                                                  )
                                                },
                                                model: {
                                                  value: item.riDayUnit,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "riDayUnit",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "item.riDayUnit"
                                                }
                                              },
                                              [
                                                _c("el-option", {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "CargoMsg.Cargo_Days"
                                                    ),
                                                    value: 0
                                                  }
                                                }),
                                                _c("el-option", {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "CargoMsg.Cargo_Month"
                                                    ),
                                                    value: 1
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            item.riDayUnit === 1
                                              ? _c(
                                                  "el-tooltip",
                                                  {
                                                    attrs: {
                                                      content: _vm.$t(
                                                        "CargoMsg.Cargo_FinanceMonthUnitTip"
                                                      ),
                                                      placement: "top"
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "el-icon-warning",
                                                      staticStyle: {
                                                        "margin-left": "2px",
                                                        color: "#E6A23C",
                                                        "font-size": "14px"
                                                      }
                                                    })
                                                  ]
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "el-form-item-wrapper" },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: _vm.$t(
                                                "CargoMsg.Cargo_IntegratedJob"
                                              )
                                            }
                                          },
                                          [
                                            _c("el-checkbox", {
                                              attrs: {
                                                no: "ie",
                                                disabled: !_vm.form
                                                  .autoFinanceSubmit
                                              },
                                              on: {
                                                change: function($event) {
                                                  return _vm.chargeFinanceLobChecked(
                                                    _vm.SystemConstants.IE.code,
                                                    item
                                                  )
                                                }
                                              },
                                              model: {
                                                value: item.ie,
                                                callback: function($$v) {
                                                  _vm.$set(item, "ie", $$v)
                                                },
                                                expression: "item.ie"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "150px" },
                                                attrs: {
                                                  no: "riDateType",
                                                  disabled: !(
                                                    _vm.form
                                                      .autoFinanceSubmit &&
                                                    item.ie
                                                  )
                                                },
                                                model: {
                                                  value: item.ieDateType,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "ieDateType",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "item.ieDateType"
                                                }
                                              },
                                              _vm._l(_vm.ieDateType, function(
                                                item
                                              ) {
                                                return _c("el-option", {
                                                  key: item.code,
                                                  attrs: {
                                                    label: item.code,
                                                    value: item.value
                                                  }
                                                })
                                              }),
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "100px" },
                                                attrs: {
                                                  value: 0,
                                                  no: "iePone",
                                                  disabled: !(
                                                    _vm.form
                                                      .autoFinanceSubmit &&
                                                    item.ie
                                                  )
                                                }
                                              },
                                              [
                                                _c("el-option", {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "CargoMsg.Cargo_GreaterThan"
                                                    ),
                                                    value: 0
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          [
                                            _c("auto-number-input", {
                                              staticStyle: { width: "100px" },
                                              attrs: {
                                                no: "riDay",
                                                disabled: !(
                                                  _vm.form.autoFinanceSubmit &&
                                                  item.ie
                                                ),
                                                "enforce-min": true,
                                                min: 0
                                              },
                                              model: {
                                                value: item.ieDay,
                                                callback: function($$v) {
                                                  _vm.$set(item, "ieDay", $$v)
                                                },
                                                expression: "item.ieDay"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: { width: "70px" },
                                                attrs: {
                                                  no: "ieDayUnit",
                                                  disabled: !(
                                                    _vm.form
                                                      .autoFinanceSubmit &&
                                                    item.ie
                                                  )
                                                },
                                                model: {
                                                  value: item.ieDayUnit,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "ieDayUnit",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "item.ieDayUnit"
                                                }
                                              },
                                              [
                                                _c("el-option", {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "CargoMsg.Cargo_Days"
                                                    ),
                                                    value: 0
                                                  }
                                                }),
                                                _c("el-option", {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "CargoMsg.Cargo_Month"
                                                    ),
                                                    value: 1
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            item.ieDayUnit === 1
                                              ? _c(
                                                  "el-tooltip",
                                                  {
                                                    attrs: {
                                                      content: _vm.$t(
                                                        "CargoMsg.Cargo_FinanceMonthUnitTip"
                                                      ),
                                                      placement: "top"
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "el-icon-warning",
                                                      staticStyle: {
                                                        "margin-left": "2px",
                                                        color: "#E6A23C",
                                                        "font-size": "14px"
                                                      }
                                                    })
                                                  ]
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]),
                                  _c("div", {
                                    staticStyle: { "padding-bottom": "5px" }
                                  })
                                ])
                              })
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ]
                  )
                ]
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }